export default __webpack_public_path__ + "static/media/google-logo-9824-32x32.06c1a7b6.ico";